enum Paths {
  DIGITAL_BENEFITS_GUIDE = "/your-benefit-guide",
  TALK_TO_CARROT = "/talk-to-carrot"
}

export { Paths }
